import React from "react";
import classNames from "classnames";

import { AccordionProps } from "./Accordion.types";
import AccordionTab from "./components/AccordionTab/AccordionTab";
import AccordionSummary from "./components/AccordionSummary/AccordionSummary";
import AccordionDetails from "./components/AccordionDetails/AccordionDetails";

import "./Accordion.scss";

const Accordion = ({ children, className }: AccordionProps) => {
  const classes = classNames("accordion", className);

  return <div className={classes}>{children}</div>;
};

Accordion.Tab = AccordionTab;
Accordion.Summary = AccordionSummary;
Accordion.Details = AccordionDetails;

export default Accordion;
